import React, { useRef, useState } from "react";
import "./ForInfluencersAudio.scss";
import gutter_lullaby from "assets/audio/gutters_lullaby.mp3";
import polluted_skyline from "assets/audio/polluted_skyline.mp3";
import vat_grown_scrap from "assets/audio/vat_grown_scrap.mp3";
import FileAudioImage from "assets/images/ForInfluencersPage/Cards/file-audio.svg";
import PlayIcon from "assets/images/ForInfluencersPage/Cards/play.svg";
import PauseIcon from "assets/images/ForInfluencersPage/Cards/pause.svg";
import DownloadBtn from "../../DownloadBtn";

type AudioCard = {
    title: string;
    src: string;
};

export const ForInfluencersAudio: React.FC = React.memo(() => {
    const audioCards: AudioCard[] = [
        {
            title: "Three A.M. in the Glitch - Vat-Grown Scrap (mp3)",
            src: vat_grown_scrap,
        },
        {
            title: "Three A.M. in the Glitch - Polluted Skyline (mp3)",
            src: polluted_skyline,
        },
        {
            title: "Three A.M. in the Glitch - Gutter's Lullaby (mp3)",
            src: gutter_lullaby,
        },
    ];

    const audioRef = useRef<HTMLAudioElement | null>(null);

    const [activeIndex, setActiveIndex] = useState<number | null>(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [hoverIndex, setHoverIndex] = useState<number | null>(null);
    const [mouseDownIndex, setMouseDownIndex] = useState<number | null>(null);

    const handleTogglePlay = (index: number) => {
        const audio = audioRef.current;
        if (!audio) {
            return;
        }

        if (activeIndex === index) {
            if (isPlaying) {
                audio.pause();
                setIsPlaying(false);
            } else {
                audio.play();
                setIsPlaying(true);
            }
            return;
        }

        setActiveIndex(index);
        audio.src = audioCards[index].src;
        audio.currentTime = 0;
        audio.play();
        setIsPlaying(true);
    };

    const handleEnded = () => {
        setIsPlaying(false);
        setActiveIndex(null);
    };

    return (
        <div className="audio-content">
            <audio ref={audioRef} onEnded={handleEnded} />

            <div className="audio-content-header">
                <p className="audio-content-title">CYBERPUNK AUDIO KIT</p>
                <p className="audio-content-subtitle">
                    Background music for your videos. Ready-to-use cyberpunk tracks <br />
                    from our studio — use for free in non-commercial content.
                </p>
            </div>
            <div className="audio-content-cards">
                {audioCards.map((card, index) => {
                    const isCardActive = activeIndex === index && isPlaying;
                    const showIcon = isCardActive || hoverIndex === index;

                    return (
                        <div className="audio-card" key={card.src}>
                            <div
                                className={
                                    "audio-card-image-container" +
                                    (mouseDownIndex === index ? " clicked" : "")
                                }
                                onMouseEnter={() => setHoverIndex(index)}
                                onMouseLeave={() => setHoverIndex(null)}
                                onMouseDown={() => setMouseDownIndex(index)}
                                onMouseUp={() => setMouseDownIndex(null)}
                                onClick={() => handleTogglePlay(index)}
                            >
                                <img src={FileAudioImage} alt="audio" className="audio-card-image" />

                                {showIcon && (
                                    <img
                                        src={isCardActive ? PauseIcon : PlayIcon}
                                        alt={isCardActive ? "pause" : "play"}
                                        className="audio-card-play-icon"
                                    />
                                )}
                            </div>

                            <p className="audio-card-title">{card.title}</p>

                            <DownloadBtn href={card.src} filename={card.title} />
                        </div>
                    );
                })}
            </div>
        </div>
    );
});